import { Table, TableCellProps, Text } from '@melio/penny';
import { Bill } from '@melio/platform-api';
import { useMelioIntl } from '@melio/platform-i18n';
import { forwardRef } from '@melio/platform-utils';

export type BillDetailsSubCellProps = TableCellProps & {
  bill: Pick<Bill, 'invoice'>;
};

export const BillDetailsSubCell = forwardRef<BillDetailsSubCellProps, 'div'>(({ bill, ...props }, ref) => {
  const { formatMessage } = useMelioIntl();

  return (
    <Table.Cell data-testid="bill-details-sub-cell" {...props} data-component="BillDetailsSubCell" ref={ref}>
      <Text textStyle="body4" color={bill.invoice.number ? 'neutral.black' : 'neutral.dark'} shouldSupportEllipsis>
        {bill.invoice.number
          ? formatMessage('activities.batchPayments.screens.paymentIntentsTable.billDetailsCell.billNumber.number', {
              invoiceNumber: bill.invoice.number,
            })
          : formatMessage(
              'activities.batchPayments.screens.paymentIntentsTable.billDetailsCell.billNumber.placeholder'
            )}
      </Text>
    </Table.Cell>
  );
});

BillDetailsSubCell.displayName = 'BillDetailsSubCell';
